// UNIT DETAILS
// ------------------------------------------------------

export const PICKABLE_PROPERTY_TYPES = [
  { label: "Single-Family", value: "single-family" },
  { label: "Multi-Family", value: "multi-family" },
  { label: "Townhouse", value: "townhouse" },
  { label: "Apartment", value: "apartment" },
  { label: "Condo", value: "condo" },
  { label: "Manufactured", value: "manufactured" },
];

export const PICKABLE_UNIT_AMENITIES = [
  {
    label: "Alarm System",
    value: "alarm-system",
    type: "checkbox",
  },
  {
    label: "Fireplace",
    value: "fireplace",
    type: "checkbox",
  },
  {
    label: "Furnished",
    value: "furnished",
    type: "checkbox",
  },
  {
    label: "Handicap Accessible",
    value: "handicap-accessible",
    type: "checkbox",
  },
  {
    label: "Vaulted Ceilings",
    value: "vaulted-ceilings",
    type: "checkbox",
  },
  {
    label: "Waterfront",
    value: "waterfront",
    type: "checkbox",
  },
];

export const PICKABLE_PETS_ALLOWED = [
  { label: "Cats", value: "cats" },
  { label: "Small Dogs", value: "small-dogs" },
  { label: "Large Dogs", value: "large-dogs" },
];

export const PICKABLE_UNIT_APPLIANCES = [
  {
    label: "Dishwasher",
    value: "dishwasher",
    type: "checkbox",
  },
  {
    label: "Dryer",
    value: "dryer",
    type: "checkbox",
  },
  {
    label: "Freezer",
    value: "freezer",
    type: "checkbox",
  },
  {
    label: "Garbage Disposal",
    value: "garbage-disposal",
    type: "checkbox",
  },
  {
    label: "Microwave",
    value: "microwave",
    type: "checkbox",
  },
  {
    label: "Oven",
    value: "oven",
    type: "checkbox",
  },
  {
    label: "Refrigerator",
    value: "refrigerator",
    type: "checkbox",
  },
  {
    label: "Washer",
    value: "washer",
    type: "checkbox",
  },
];

export const PICKABLE_UNIT_COOLING_SYSTEMS = [
  {
    label: "Central",
    value: "central",
    type: "checkbox",
  },
  {
    label: "Evaporative",
    value: "evaporative",
    type: "checkbox",
  },
  {
    label: "Geothermal",
    value: "geothermal",
    type: "checkbox",
  },
  {
    label: "Solar",
    value: "solar",
    type: "checkbox",
  },
  {
    label: "Wall",
    value: "wall",
    type: "checkbox",
  },
];

export const PICKABLE_UNIT_FLOOR_COVERINGS = [
  {
    label: "Carpet",
    value: "carpet",
    type: "checkbox",
  },
  {
    label: "Concrete",
    value: "concrete",
    type: "checkbox",
  },
  {
    label: "Hardwood",
    value: "hardwood",
    type: "checkbox",
  },
  {
    label: "Laminate",
    value: "laminate",
    type: "checkbox",
  },
  {
    label: "Linoleum",
    value: "linoleum",
    type: "checkbox",
  },
  {
    label: "Stone",
    value: "stone",
    type: "checkbox",
  },
  {
    label: "Softwood",
    value: "softwood",
    type: "checkbox",
  },
  {
    label: "Tile",
    value: "tile",
    type: "checkbox",
  },
  {
    label: "Vinyl",
    value: "vinyl",
    type: "checkbox",
  },
];

export const PICKABLE_UNIT_HEATING_SYSTEMS = [
  {
    label: "Baseboard",
    value: "baseboard",
    type: "checkbox",
  },
  {
    label: "Forced Air",
    value: "forced-air",
    type: "checkbox",
  },
  {
    label: "Geothermal",
    value: "geothermal",
    type: "checkbox",
  },
  {
    label: "Heat Pump",
    value: "heat-pump",
    type: "checkbox",
  },
  {
    label: "Radiant",
    value: "radiant",
    type: "checkbox",
  },
  {
    label: "Stove",
    value: "stove",
    type: "checkbox",
  },
  {
    label: "Wall",
    value: "wall",
    type: "checkbox",
  },
];

export const PICKABLE_UNIT_DETAILS = [
  {
    label: "# of Bedrooms",
    value: "bedrooms",
    type: "number",
  },
  {
    label: "# of Full Bathrooms",
    value: "fullBathrooms",
    type: "number",
  },
  {
    label: "# of Half Bathrooms",
    value: "halfBathrooms",
    type: "number",
  },
  {
    label: "Balcony/Deck/Patio",
    value: "balconyDeckPatio",
    type: "checkbox",
  },
  {
    label: "Basement",
    value: "basement",
    type: "checkbox",
  },
  {
    label: "Parking Spaces",
    value: "parkingSpaces",
    type: "number",
  },
  {
    label: "Square Footage",
    value: "squareFootage",
    type: "number",
  },

  {
    label: "Fenced Yard",
    value: "fencedYard",
    type: "checkbox",
  },
  {
    label: "Garage",
    value: "garage",
    type: "checkbox",
  },
];

export const PICKABLE_UNIT_UTILITIES = [
  {
    label: "Cable",
    value: "cable",
    type: "checkbox",
  },
  {
    label: "Electric",
    value: "electric",
    type: "checkbox",
  },
  {
    label: "Garbage",
    value: "garbage",
    type: "checkbox",
  },
  {
    label: "Internet",
    value: "internet",
    type: "checkbox",
  },
  {
    label: "Water",
    value: "water",
    type: "checkbox",
  },
  {
    label: "Sewage",
    value: "sewage",
    type: "checkbox",
  },
  { label: "Landscaping", value: "landscaping", type: "checkbox" },
  {
    label: "Snow",
    value: "snow",
    type: "checkbox",
  },
];

export const UNIT_MARKETING_ALLOWED_VIDEO_TOUR_URLS = [
  "youtube.com/watch?v=",
  "youtu.be/",
  "youtube.com/",
  "vimeo.com/",
  "rumble.com/",
];

export const UNIT_MARKETING_ALLOWED_VIRTUAL_TOUR_URLS = ["matterport.com/"];
